var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgColumns = function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.929 3.498c.305 0 .552.247.552.552v7.177a.552.552 0 0 1-1.104 0V4.05c0-.305.247-.552.552-.552Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.617 3.498c.304 0 .552.247.552.552v7.177a.552.552 0 1 1-1.105 0V4.05c0-.305.248-.552.553-.552ZM4.304 3.498c.305 0 .552.247.552.552v7.177a.552.552 0 1 1-1.104 0V4.05c0-.305.247-.552.552-.552Z"
  })));
};

export default SvgColumns;